import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppBarTitleService, AppPageService } from 'common';
import { UserData } from '../user.model';
import { UserRoleData } from '../../../user/user-role/user-role.data';

@UntilDestroy()
@Component({
    selector: 'ifb-user-details',
    templateUrl: './user-details.component.html',
    styleUrls: ['./user-details.component.scss'],
    standalone: false
})

export class UserDetailsComponent implements OnInit {
  data: UserDetailsComponentData;
  roles: UserRoleData[];

  constructor(
    private readonly route: ActivatedRoute,
    private readonly appBarTitleService: AppBarTitleService,
    private readonly appPageService: AppPageService
  ) { }

  ngOnInit(): void {
    this.route.data.pipe(untilDestroyed(this)).subscribe(this.initData.bind(this))
  }

  private initData(data: UserDetailsComponentData): void {
    this.data = data;
    this.roles = data.user.roles;
    this.appBarTitleService.title = data.user.firstName && data.user.lastName ? data.user.firstName + ' ' + data.user.lastName : '';
  }

  cancel(): void {
    this.appPageService.back();
  }
}

export interface UserDetailsComponentData {
  user: UserData;
  roles: UserRoleData[];
}
